import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="py-24 md:py-32 bg-[#F8FAFC]">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <h1 className="text-5xl md:text-6xl font-light tracking-tight text-[#0B1B32] mb-6" data-testid="terms-title">
            Terms & Conditions
          </h1>
          <p className="text-slate-600">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <div className="prose prose-lg max-w-none space-y-8">
            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">1. General Terms</h2>
              <p className="text-slate-600 leading-relaxed">
                By accessing and using Vista Global Trade's services, you agree to be bound by these Terms and Conditions. These terms apply to all visitors, users, and others who access or use our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">2. Services Scope</h2>
              <p className="text-slate-600 leading-relaxed">
                Vista Global Trade provides sourcing and export coordination services for agricultural products from India. We facilitate connections between suppliers and buyers but do not guarantee specific outcomes or delivery timelines beyond what is agreed in individual contracts.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">3. Product Quality</h2>
              <p className="text-slate-600 leading-relaxed">
                While we exercise due diligence in quality inspection, all products are subject to natural variations inherent in agricultural commodities. Final specifications are agreed upon in individual purchase contracts. Sample approval and third-party inspection options are available upon request.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">4. Pricing and Payment</h2>
              <p className="text-slate-600 leading-relaxed">
                All pricing is subject to confirmation and may vary based on market conditions, quantities, and specifications. Payment terms are agreed upon in individual contracts. We reserve the right to modify pricing based on currency fluctuations and commodity market changes.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">5. Shipping and Delivery</h2>
              <p className="text-slate-600 leading-relaxed">
                Shipping timelines are estimates and may be affected by factors beyond our control including weather, port congestion, and regulatory delays. FOB, CIF, and other Incoterms are specified in individual contracts. Risk transfer occurs as per agreed Incoterms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">6. Limitation of Liability</h2>
              <p className="text-slate-600 leading-relaxed">
                Vista Global Trade shall not be liable for indirect, consequential, or incidental damages arising from the use of our services. Our liability is limited to the value of the specific transaction in question. We are not responsible for losses due to market price fluctuations or third-party actions.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">7. Force Majeure</h2>
              <p className="text-slate-600 leading-relaxed">
                We shall not be held responsible for delays or failures in performance resulting from acts beyond our reasonable control, including but not limited to natural disasters, strikes, wars, government restrictions, or pandemics.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">8. Dispute Resolution</h2>
              <p className="text-slate-600 leading-relaxed">
                Any disputes arising from these terms or from our services shall be resolved through arbitration in Delhi, India. The governing law shall be the laws of India.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">9. Modification of Terms</h2>
              <p className="text-slate-600 leading-relaxed">
                Vista Global Trade reserves the right to modify these terms at any time. Continued use of our services after modifications constitutes acceptance of the updated terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">10. Contact Information</h2>
              <p className="text-slate-600 leading-relaxed">
                For questions regarding these terms, please contact us at info@vistaglobaltrade.com or +91 8882062043.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;